import React,{useState, useEffect, useContext} from 'react'
// Import the main component
import { Viewer } from '@react-pdf-viewer/core'; // install this library
// Plugins
//import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'; // install this library
//import { searchPlugin } from '@react-pdf-viewer/search';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
//import { ToolbarSlot, TransformToolbarSlot } from '@react-pdf-viewer/toolbar';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
//import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// Worker
import { Worker } from '@react-pdf-viewer/core'; // install this library
import { Card } from 'react-bootstrap';
//import { pdfJournalData } from '../../ProData';
import {Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap";
import { Col, Row, Button, Form, ButtonGroup, Breadcrumb, InputGroup,  Dropdown, Table} from 'react-bootstrap';

import axios from 'axios';
import { ProductContext } from '../../ProductProvider';
import Preloader from "../../components/Preloader/Preloader";
import { fetchAuthSession } from 'aws-amplify/auth';
import AddPDF from './AddPDF';
import { useSnackbar } from 'notistack';

//import pope from '../../assets/img/popefrancis.jpg';
const config = require('../../config.json');

export const ViewPDF = () => {
  // for onchange event
  const { pdfFormType, setPDFFormType, setPDFDetails, loggedUser, validateLogin } = useContext(ProductContext);
  const { enqueueSnackbar } = useSnackbar();
  const [pdfFile, setPdfFile]=useState(null);
  const [showPDF, setShowPDF]=useState(false);
  const [pdfJournalDetails, setPDFJournalDetails] = useState([]);
  const [loaded, setLoaded] = useState(true);
  const [collapsed, setCollapsed] = useState(true);
  const [showComments, setShowComments] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [searchTopic, setSearchTopic] = useState('JournalID');
  const [cardView, setCardView] = useState(true); 
  const [selectedItem, setSelectedItem] = useState([]);
  const [displayComments, setDisplayComments] = useState([]);
  // Create new plugin instance
  //const defaultLayoutPluginInstance = defaultLayoutPlugin();
  //const searchPluginInstance = searchPlugin();
  const toolbarPluginInstance = toolbarPlugin();
  const { renderDefaultToolbar, Toolbar } = toolbarPluginInstance;
  const componentRef = React.useRef(null);
  const componentCommentsRef = React.useRef(null);

  useEffect(()=>{
    if(loggedUser.isAuthenticated){
      //processBatchYear();
    }else{
    validateLogin();
    }
    
   // console.log(batchYear);
  },[loggedUser])

  const toggle = () => {
    //   console.log("clicked");
         setCollapsed(!collapsed);
  }

  const commentsToggleOn=(event, item)=>{
    event.preventDefault();
    //console.log("Item : ", item);
    setShowComments(false);
    setSelectedItem(item);
    item.comments=item.comments?item.comments:[];
    setDisplayComments(item.comments);
  }

  const commentsToggleOff=(event)=>{
    event.preventDefault();
    setShowComments(true);
    //setSelectedItem();
    //setDisplayComments([]);
  }

  const fetchJournalDetails=async(event)=>{
    event.preventDefault();
    try{
      if(searchValue===""){
        enqueueSnackbar("Search Value cannot be Empty!",{variant:'info'});
      }else{
      setLoaded(false);
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      //const clientID="VJJournal";
      //const searchOption="Status";
      //const searchValue="Active";
      //console.log(searchTopic, searchValue);
      await axios.get(`${config.api.invokeUrl}/journal/search?searchOption=${searchTopic}&searchValue=${searchValue}`,{
          headers: {
            Authorization: idToken,
            'x-api-key': config.api.key
          }}, 
      ).then((response)=>{
        //console.log("Response : ", response);
        setPDFJournalDetails(response.data);
        enqueueSnackbar(response.data.length + " - " + searchTopic + " Journals Found",{variant:'success'});
          //console.log(response);
          setLoaded(true);
      }).catch((error)=>{
          //console.log(error);
          enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
          setLoaded(true);
          //setDispMsg(error.message);
      })
      }
  }catch(error){
    enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
      setLoaded(true);
  }
  }
  

  const transform = (slot) => ({
      ...slot,
      Download: () => <></>,
      DownloadMenuItem: () => <></>,
      Open: () => <></>,
      OpenMenuItem: () => <></>,
      Print: () => <></>,
      PrintMenuItem: () => <></>,
      //EnterFullScreen: () => <></>,
      //EnterFullScreenMenuItem: () => <></>,
      SwitchTheme: () => <></>,
      SwitchThemeMenuItem: () => <></>,
  });

const handleFetchPDF = async(e, item) => {
    e.preventDefault();
    //console.log("fetch : ", item);
    try{
      const fetchFile=item.journalID+".pdf";
      //console.log("fetch file :", fetchFile);
      const bucketName='docs.vidyajyotijournal.com/pdfs';
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      await axios.get(`${config.api.invokeUrl}/presigned/downloader?fileName=${fetchFile}&bucketName=${bucketName}`,{
        headers: {
          Authorization: idToken,
          'x-api-key': config.api.key
        }}, 
     ).then(async(response)=>{
          //console.log("Response : ", response);
          setPdfFile(response.data.downloadURL);
          setShowPDF(true); 

          /*await axios.get(response.data.downloadURL,{
            responseType:'arraybuffer',
            headers: {
              "Content-Type": "application/json",
              "Accept":"application/pdf",
              //"content-disposition": "attachment; filename=test.pdf",
              "access-control-allow-origin" : "*",
            }
          })
          .then(function(pdfresponse){
           console.log("pdf response : ", pdfresponse);
           let blob = new Blob([pdfresponse.data], {type: 'application/pdf'});
           const link = document.createElement('a');
           link.href = URL.createObjectURL(blob);
           console.log("link.href : ", link);
          // setPdfFile(pdfresponse.data);
          // setShowPDF(true); 
 
          })*/
      }).catch((error)=>{
          console.log("Error1 : ", error);
          //setDispMsg("Error Occured - ", error.message);
      })        
    }catch(error){
        console.log("Error2 : ", error);
    }
}

const handleBack=(e)=>{
  e.preventDefault();
  setPdfFile('');
  setShowPDF(false); 
}

const handlePageChange = (e) => {
  localStorage.setItem('current-page', `${e.currentPage}`);
};

const handleSwitchTheme = (theme) => {
  localStorage.setItem('current-theme', theme);
};

const handleEditPDF=(e, item,action)=>{
e.preventDefault();
try{
  setPDFFormType(action);
  setPDFDetails(item);
  toggle();
}catch(error){
  enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
}
}

const handleSearchSelection=(event)=>{
  setSearchTopic(event.target.value);
  if(event.target.value==="JournalStatus"){
    setSearchValue("Active");
  }else if(event.target.value==="JournalCategory"){
    setSearchValue("Book Review");
  }else{
    setSearchValue('');
  }
}

const handleLayoutChange=(event, mode)=>{
  event.preventDefault();
  if(mode==="List"){
    setCardView(false);
  }else{
    setCardView(true);
  }
}



  return (
    <div className='container'>
       <Preloader show={loaded ? false : true} />
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><i className="fa fa-home" aria-hidden="true"></i></Breadcrumb.Item>
            <Breadcrumb.Item>Publications</Breadcrumb.Item>
            <Breadcrumb.Item active>Manage</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Publications</h4>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0"> 
          <ButtonGroup>
          <Button variant="primary outline-success" size="sm" onClick={(event=>handleLayoutChange(event, "List"))}><i className="fa fa-list" aria-hidden="true"></i></Button>
         <Button variant="success outline-primary" size="sm" onClick={(event=>handleLayoutChange(event, "Card"))} ><i className="fa fa-th-large " aria-hidden="true"></i></Button>
          </ButtonGroup>
  </div>
      </div>
     

         {/*View*/}
         <div >
          <Modal onHide={toggle} show={!collapsed} size="lg">
          <div>
             <Modal.Header  toggle={toggle} closeButton>
               Registration Form - {pdfFormType}
                    </Modal.Header>
                    <Modal.Body >    
                        <AddPDF toggle={toggle} fetchJournalDetails={fetchJournalDetails}/> 
                    </Modal.Body>
             {/*}       <ModalFooter>
            {' '}
            
            <Button onClick={toggle}>
                Close
            </Button>
            </ModalFooter>*/}
          </div>
                   
        </Modal>
        </div>

        {/*Show Comments*/}
         <div >
          <Modal onHide={commentsToggleOff} show={!showComments} size="lg">
          <div>
             <Modal.Header  toggle={toggle} closeButton>
               Comments for - {selectedItem.journalID}
                    </Modal.Header>
                    <Modal.Body >    
                        {displayComments.length>0 ? <Table ref={componentCommentsRef} hover responsive>
                        <thead>
                        <tr>
                          <th>#</th>
                          <th>ID</th>
                          <th>Comments</th>
                          <th>Display</th>
                          <th>Submitted On</th>
                          <th>Submitted By</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                      {displayComments.map((item, index)=>
                      <tr key={index}>
                      <th scope="row">{index+1}</th>
                      <td>{item.id}</td>
                      <td>{item.comments}</td>
                      <td>{item.display?<i className="fa fa-check" aria-hidden="true"></i>:<i className="fa fa-times" aria-hidden="true"></i>}</td>
                      <td>{new Date(item.submittedOn).toLocaleDateString('en-us', { year:"numeric", month:"long"})}</td>
                      <td>{item.submittedBy}</td>
                      <td>
                      {/*<Dropdown as={ButtonGroup}>
                      <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
                        <span className="icon icon-sm">
                        <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item  onClick={(event)=>{handleEditPDF(event, item,"View")}}>
                        <i className="fa fa-eye" aria-hidden="true"></i> Toggle Display
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>*/}
                      </td>
                      </tr>)}
                      </tbody>
                  </Table>:<p>No Comments Available</p>}
                    </Modal.Body>
            <ModalFooter>
            {' '}
            <Button onClick={event=>commentsToggleOff(event)}>
                Close
            </Button>
            </ModalFooter>
          </div>
                   
        </Modal>
        </div>

        <div className="table-settings mb-4">
        <form onSubmit={(e)=>{fetchJournalDetails(e)}}>
        <Row className="justify-content-start align-items-center">
        <Col md={4} className="mb-3">
              <Form.Group id="searchstud">               
                <Form.Select defaultValue="JournalID" value={searchTopic} onChange={(event)=>{handleSearchSelection(event)}}>
               {/*} <option value="Issue">Issue</option>*/}
                <option value="JournalID">Journal ID</option>
                <option value="JournalCategory">Journal Category</option>
                <option value="AuthorName">Author Name</option>
                <option value="JournalStatus">Status</option>
                </Form.Select>
              </Form.Group>
            </Col>
          <Col  className="mb-3" md={8}>
            <InputGroup>
              <InputGroup.Text>
              <i className="fa fa-search" aria-hidden="true"></i>
              </InputGroup.Text>
              {searchTopic==="JournalStatus"?           
              <Form.Select value={searchValue} 
                  onChange={(event)=>{setSearchValue(event.target.value)}}>
                  <option value="Active">Active</option>
                  <option value="Archive">Archive</option>
                  <option value="In-Active">In-Active</option>                    
            </Form.Select>:searchTopic==="JournalCategory"?           
              <Form.Select value={searchValue} 
                  onChange={(event)=>{setSearchValue(event.target.value)}}>
                  <option value="Book Review">Book Review</option>
                  <option value="Editorial Section">Editorial Section</option>
                  <option value="Articles">Articles</option>
                  <option value="Full Issue">Full Issue</option>            
                </Form.Select>:searchTopic==="Issue"? 
            <Form.Control type="month" placeholder="Search" autoFocus value={searchValue} onChange={(event)=>{setSearchValue(event.target.value)}}/>:
            <Form.Control type="text" placeholder="Search" autoFocus value={searchValue} onChange={(event)=>{setSearchValue(event.target.value)}}/>}
              <Button variant="primary" type="submit" onClick={(event)=>{fetchJournalDetails(event)}}>Submit</Button>
            </InputGroup>
          </Col>
        </Row>
        </form>
      </div>


    {cardView ? <Row style={{padding:"5px"}}> 

    {!showPDF && pdfJournalDetails.map((item,index)=><>
                   
      <Col key={index} md={4}>
            <Card key={index}>
                <Card.Img style={{height:'200px'}}  variant="top" src={`${config.s3.pdfImginvokeUrl}${item.journalID}.jpeg`} />
                  <span style={{position:'absolute',top:10,right:10,background:'#fff',color:'#1a237e',fontWeight:600,padding:'2px 10px',borderRadius:12,fontSize:'0.95rem',boxShadow:'0 1px 4px #0001'}}>{item.journalCategory}</span>
                <Card.Body>
                <Card.Title style={{fontSize:"14px", height:'80px', textAlign:"center"}}>{item.journalName} 
                <p style={{fontSize:"12px", height:'05px'}}><i>{item.authorName} </i></p>
                <p style={{fontSize:"12px", height:'10px'}}><i>{new Date(item.publishDate).toLocaleDateString('en-us', { year:"numeric", month:"long"})}</i></p></Card.Title>
                <Card.Text style={{fontSize:"12px", height:"130px", overflow:'hidden'}}>
                    {item.description}
                </Card.Text>
                </Card.Body>
                <Card.Footer>
                    <small className="text-muted">{item.rating}</small>
                    <div className='d-flex justify-content-between'>
                      <div id="metrics" className="modern-metrics-bar border-top pt-2 mt-2">
                                <div className="metrics-item metrics-likes" title={item.journalID} style={{cursor: 'pointer', opacity: 1}}>
                                  <span className="metrics-icon-bg metrics-like-bg"><i className="fa fa-thumbs-up" aria-hidden="true"></i></span>
                                  <span className="metrics-count">{item.likes}</span>
                                </div>
                               
                                <div className="metrics-item metrics-views">
                                  <span className="metrics-icon-bg metrics-view-bg"><i className="fa fa-eye" aria-hidden="true"></i></span>
                                  <span className="metrics-count">{item.noOfViews}</span>
                                </div>
                                <div className="metrics-item metrics-comments" title={item.journalID} style={{cursor: 'pointer', opacity: 0.6}}>
                                  <span className="metrics-icon-bg metrics-comment-bg"><i className="fa fa-commenting" aria-hidden="true"></i></span>
                                  <span className="metrics-count">{item.comments?item.comments.length:0}</span>
                                </div>
                                <Button
                                  variant="outline-success"
                                  size="sm"
                                  className="metrics-item metrics-pdf mx-2"
                                  style={{fontWeight:600, borderRadius:8, borderWidth:1.5, boxShadow:'0 1px 4px #0001', top:"10px"}}
                                    onClick={event=>{handleEditPDF(event, item,"Edit")}}
                                  title="Edit PDF"
                                >
                                  <span className="metrics-icon-bg metrics-pdf-bg"><i className="fa fa-pencil" aria-hidden="true"></i>  </span>
                                  <span className="metrics-label">Edit</span>
                                </Button>
                                 <Button
                                  variant="outline-success"
                                  size="sm"
                                  className="metrics-item metrics-pdf mx-2"
                                  style={{fontWeight:600, borderRadius:8, borderWidth:1.5, boxShadow:'0 1px 4px #0001', top:"10px"}}
                                  onClick={e => { handleFetchPDF(e, item) }}
                                  title="View PDF"
                                >
                                  <span className="metrics-icon-bg metrics-pdf-bg"><i className="fa fa-file-pdf"></i></span>
                                  <span className="metrics-label">Read</span>
                                </Button>
                                <style>{`
                                  .modern-metrics-bar {
                                    display: flex;
                                    flex-wrap: wrap;
                                    justify-content: center;
                                    align-items: center;
                                    gap: 1.2rem;
                                    font-size: 1.08rem;
                                    background: #f6f8fa;
                                    border-radius: 0 0 1.1rem 1.1rem;
                                    min-height: 48px;
                                    width: 100%;
                                  }
                                  .metrics-item {
                                    display: flex;
                                    align-items: center;
                                    gap: 0.45em;
                                    font-weight: 600;
                                    padding: 0.32em 0.9em 0.32em 0.7em;
                                    border-radius: 1.2em;
                                    background: #fff;
                                    box-shadow: 0 1px 4px #0001;
                                    transition: box-shadow 0.18s, background 0.18s, transform 0.18s;
                                    user-select: none;
                                    min-width: 70px;
                                    flex: 1 1 0;
                                    justify-content: center;
                                  }
                                  .metrics-item:hover {
                                    background: #e3e8f7;
                                    box-shadow: 0 2px 8px #1a237e22;
                                    transform: translateY(-2px) scale(1.04);
                                  }
                                  .metrics-icon-bg {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    width: 2em;
                                    height: 2em;
                                    border-radius: 50%;
                                    background: #e3e8f7;
                                    margin-right: 0.3em;
                                    font-size: 1.15em;
                                  }
                                  .metrics-like-bg { background: #e3e8f7; color: #1976d2; }
                                  .metrics-pdf-bg { background: #fbe9e7; color: #d32f2f; }
                                  .metrics-view-bg { background: #e8f5e9; color: #388e3c; }
                                  .metrics-comment-bg { background: #f3e5f5; color: #7b1fa2; }
                                  .metrics-count {
                                    font-size: 1.08em;
                                    font-weight: 700;
                                    margin-left: 0.1em;
                                  }
                                  .metrics-label {
                                    font-size: 1.01em;
                                    font-weight: 600;
                                    margin-left: 0.2em;
                                  }
                                  @media (max-width: 576px) {
                                    .modern-metrics-bar {
                                      gap: 0.3rem;
                                      font-size: 0.97rem;
                                      min-height: 36px;
                                      flex-wrap: wrap;
                                    }
                                    .metrics-item {
                                      padding: 0.18em 0.35em 0.18em 0.3em;
                                      font-size: 0.96em;
                                      min-width: 60px;
                                      flex: 1 1 40%;
                                      margin-bottom: 0.2em;
                                    }
                                    .metrics-icon-bg { width: 1.3em; height: 1.3em; font-size: 0.98em; }
                                  }
                                `}</style>
                              </div>
                   {/*} <i className="fa fa-pencil" aria-hidden="true" onClick={event=>{handleEditPDF(event, item,"Edit")}}></i>                      
                    <i className="fa fa-book" aria-hidden="true" onClick={event=>{handleFetchPDF(event, item)}}></i>*/}
                    </div>
                    <div >
                    </div>
                   <div>
                   </div>
                </Card.Footer>
            </Card>
       </Col>
    </>)}
    
     </Row>:
     <>
      {pdfJournalDetails.length>0 && <Table ref={componentRef} hover responsive>
      <thead>
       <tr>
         <th>#</th>
         <th>Journal ID</th>
         <th>Title</th>
         <th>Author</th>
         <th>Likes</th>
         <th>Views</th>
         <th>Comments</th>
         <th>Publish Date</th>
         <th>Status</th>
        <th>Action</th>
       </tr>
     </thead>
     <tbody>
     {pdfJournalDetails.map((item, index)=>
     <tr key={index}>
     <th scope="row">{index+1}</th>
     <td>{item.journalID}</td>
     <td>{item.journalName}</td>
     <td>{item.authorName}</td>
     <td>{item.likes?item.likes:0}</td>
     <td>{item.noOfViews?item.noOfViews:0}</td>
     <td>{item.comments?item.comments.length:0}</td>
     <td>{new Date(item.publishDate).toLocaleDateString('en-us', { year:"numeric", month:"long"})}</td>
     <td>{item.journalStatus==="Archive"?<p style={{backgroundColor:"blue", borderRadius:"10px", textAlign:"center", color:"white"}}>Archive</p>:
     item.journalStatus==="Active"?<p style={{backgroundColor:"green", borderRadius:"10px", textAlign:"center", color:"white"}}>Active</p>:
     <p style={{backgroundColor:"red", borderRadius:"10px", textAlign:"center", color:"white"}}>In-Active</p>}</td>
    <td>
    <Dropdown as={ButtonGroup}>
     <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
       <span className="icon icon-sm">
       <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
       </span>
     </Dropdown.Toggle>
     <Dropdown.Menu>
       <Dropdown.Item  onClick={(event)=>{handleEditPDF(event, item,"View")}}>
       <i className="fa fa-eye" aria-hidden="true"></i> View Details
       </Dropdown.Item>
       <Dropdown.Item  onClick={(event)=>{handleEditPDF(event, item,"Edit")}}>
       <i className="fa fa-pencil" aria-hidden="true"></i> Edit Details
       </Dropdown.Item>
       <Dropdown.Item  onClick={(event)=>{commentsToggleOn(event, item)}}>
       <i className="fa fa-book" aria-hidden="true"></i> View Comments
       </Dropdown.Item>
       <Dropdown.Item  onClick={(event)=>{handleFetchPDF(event, item)}}>
       <i className="fa fa-book" aria-hidden="true"></i> View Journal
       </Dropdown.Item>

     </Dropdown.Menu>
   </Dropdown>
     </td>
     </tr>)}
     </tbody>
</Table>}</>}

    {showPDF && <div style={{height:800}}>
      <div>
      <i className="fa fa-backward" aria-hidden="true" onClick={event=>{handleBack(event)}}></i> Go Back
      </div>


        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">

        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
          <Viewer fileUrl={pdfFile}  onPageChange={handlePageChange} plugins={[toolbarPluginInstance]} theme="auto"
          onSwitchTheme={handleSwitchTheme}
             />
      </Worker>

      </div>}
      {/*<div
            className="rpv-core__viewer"
            style={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}
        >
            <div
                style={{
                    alignItems: 'center',
                    backgroundColor: '#eeeeee',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    padding: '0.25rem',
                }}
            >
                <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
            </div>
            <div
                style={{
                    flex: 1,
                    overflow: 'hidden',
                }}
            ><Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <Viewer fileUrl={url} plugins={[toolbarPluginInstance]} />
                </Worker>
            </div>
            </div>*/}

    </div>
  )
}

export default ViewPDF;